import { pl } from './date.locale';

interface DateCoreConfig {
  locale: Locale;
}

export const defaultConfig: DateCoreConfig = { locale: pl };
export const config: DateCoreConfig = defaultConfig;
